const REGEX_METACHARS = /[\\^$.|?*+()[\]{}]/g;

/**
 * The pattern a card uses to mark the words of a search in its text.
 *
 * Each word is escaped before being joined, so what the user typed is matched as text: a bracket
 * used to reach `new RegExp` raw, throw while the cards rendered, and blank the whole page. A '*' is
 * dropped rather than escaped, because the search bar reads it as a wildcard ("Metsol*").
 *
 * @param search the search bar's text, words separated by spaces
 * @returns the pattern, or null when there is no word to mark
 */
export function searchHighlightRegExp(search: string): RegExp | null {
    const words = search
        .split(/\s+/)
        .map(word => word.replace(/\*/g, ''))
        .filter(word => word.length > 0)
        .map(word => word.replace(REGEX_METACHARS, '\\$&'));

    return words.length > 0 ? new RegExp(words.join('|'), 'ig') : null;
}
